import { render, staticRenderFns } from "./PublicWelfareClassList.vue?vue&type=template&id=436010b0&scoped=true"
import script from "./PublicWelfareClassList.vue?vue&type=script&lang=js"
export * from "./PublicWelfareClassList.vue?vue&type=script&lang=js"
import style0 from "./PublicWelfareClassList.vue?vue&type=style&index=0&id=436010b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436010b0",
  null
  
)

export default component.exports